module.exports = __webpack_public_path__ + "static/media/period.58a924b0.png";